import React from "react"
import { TYPOGRAPHY } from "../constants/theme"

const DropdownFilter = ({ selectedIds = [], data = [], isOpen, setIsOpen, dropdownRef, onToggle, onSelectAll, placeholder = "ทั้งหมด" }) => {
	const selectedCount = selectedIds.length
	const allSelected = data.length > 0 && selectedCount === data.length

	const renderSummary = () => {
		if (selectedCount === 0) return <span>{placeholder}</span>
		if (selectedCount === 1) {
			const campaign = data.find((c) => c.id === selectedIds[0])
			return <span>{campaign?.name || placeholder}</span>
		}
		const displayNames = selectedIds
			.slice(0, 2)
			.map((id) => data.find((c) => c.id === id)?.name)
			.filter(Boolean)
		const remaining = selectedCount - displayNames.length
		return (
			<div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
				<div
					style={{
						fontSize: TYPOGRAPHY.fontSize.xs,
						color: "#4b5563",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
						maxWidth: "180px",
					}}
					title={selectedIds
						.map((id) => data.find((c) => c.id === id)?.name)
						.filter(Boolean)
						.join(", ")}
				>
					{displayNames.join(", ")}
					{remaining > 0 && ` +${remaining} รายการ`}
				</div>
			</div>
		)
	}

	return (
		<div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
			<div
				onClick={() => setIsOpen(!isOpen)}
				style={{
					border: "1px solid #d1d5db",
					borderRadius: "6px",
					background: "white",
					cursor: "pointer",
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					width: "100%",
					minHeight: "40px",
					padding: selectedCount > 1 ? "6px 12px" : "8px 12px",
					fontSize: TYPOGRAPHY.fontSize.sm,
					color: "#374151",
					fontFamily: TYPOGRAPHY.fontFamily,
				}}
			>
				<div style={{ flex: 1, overflow: "hidden" }}>{renderSummary()}</div>
				<span style={{ marginLeft: "8px", transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>▼</span>
			</div>
			{isOpen && (
				<div
					style={{
						position: "absolute",
						top: "100%",
						left: 0,
						right: 0,
						background: "white",
						border: "1px solid #ddd",
						borderRadius: "6px",
						boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
						zIndex: 1000,
						maxHeight: "220px",
						overflowY: "auto",
						padding: "8px",
						marginTop: "6px",
					}}
				>
					<div style={{ padding: "6px 8px", borderBottom: "1px solid #eee", marginBottom: "6px" }}>
						<label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "bold" }}>
							<input type="checkbox" checked={allSelected} onChange={onSelectAll} style={{ marginRight: "8px" }} />
							เลือกทั้งหมด
						</label>
					</div>
					{data.map((item) => (
						<div key={item.id} style={{ padding: "4px 8px" }}>
							<label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: TYPOGRAPHY.fontSize.sm }}>
								<input type="checkbox" checked={selectedIds.includes(item.id)} onChange={() => onToggle(item.id)} style={{ marginRight: "8px" }} />
								{item.name}
							</label>
						</div>
					))}
				</div>
			)}
		</div>
	)
}

export default DropdownFilter
